import React from 'react';

/**
 * Tiny inline SVG sparkline — reusable across dashboards.
 * Props: data (array of numbers), width, height, color, showDot (default true)
 */
export default function Sparkline({ data = [], width = 60, height = 16, color = '#22d3ee', showDot = true, showArea = false }) {
  if (!data.length) return null;
  const max = Math.max(1, ...data);
  const step = width / Math.max(1, data.length - 1);
  const pts = data.map((v, i) => `${i * step},${height - (v / max) * (height - 2) - 1}`).join(' ');
  const areaPts = `0,${height} ${pts} ${width},${height}`;
  const last = data[data.length - 1];
  const lastX = (data.length - 1) * step;
  const lastY = height - (last / max) * (height - 2) - 1;
  return (
    <svg width={width} height={height} className="inline-block align-middle" data-testid="sparkline">
      {showArea && (
        <polygon points={areaPts} fill={color} opacity="0.18" />
      )}
      <polyline points={pts} fill="none" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      {showDot && <circle cx={lastX} cy={lastY} r="2" fill={color} />}
    </svg>
  );
}
